module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Social-Image.38cd806e.jpg";